export const typedObjectEntries = <TKey, TValue>(obj: {
  [TKey]: TValue,
}): Array<[TKey, TValue]> => {
  return (Object.entries(obj): any);
};
